import { Pipe, PipeTransform } from '@angular/core';
import { Currency } from '@data-access';

@Pipe({
  name: 'fr8BotCurrency',
  pure: true,
  standalone: true,
})
export class Fr8BotCurrencyPipe implements PipeTransform {
  private static readonly formatters = new Map<string, Intl.NumberFormat>();

  transform(value?: number | null, currencyCode: Currency = Currency.Usd): string {
    if (value == null) return '';

    const fractionDigits = Number.isInteger(value) ? 0 : 2;
    const key = `${currencyCode}:${fractionDigits}`;

    let formatter = Fr8BotCurrencyPipe.formatters.get(key);
    if (!formatter) {
      formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currencyCode,
        currencyDisplay: 'narrowSymbol',
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits,
      });
      Fr8BotCurrencyPipe.formatters.set(key, formatter);
    }

    // Mexican peso shares the "$" narrow symbol with USD, so replace it with "Mex" to disambiguate.
    if (currencyCode === Currency.Mxn) {
      return formatter.format(value).replace('$', 'Mex$');
    }

    return formatter.format(value);
  }
}
